export const unescapeHtml = (escapedHTML) => {
  return escapedHTML
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&amp;/gi, "&");
};
